import React from 'react';
import { sortableElement, sortableHandle } from 'react-sortable-hoc';

import GragIcon from '../../../assets/icons/drag.svg';
import { IconDragCategories } from '../../Collection/Collection.styles';

const preventNativeDrag = (event) => {
    event.preventDefault();
};

export const SubCollectionDragHandle = sortableHandle(() => (
    <span
        className="subcollection-drag-handle"
        onClick={(e) => e.stopPropagation()}
        onDragStart={preventNativeDrag}
        style={{
            display: 'inline-flex',
            alignItems: 'center',
            cursor: 'default',
            touchAction: 'none',
            marginRight: 8,
            flexShrink: 0,
            userSelect: 'none',
        }}
    >
        <IconDragCategories
            src={GragIcon}
            alt=""
            draggable={false}
            onDragStart={preventNativeDrag}
        />
    </span>
));

const SortableSubCollectionRow = sortableElement(({ children }) => (
    <div className="sortable-subcollection-row">{children}</div>
));

export default SortableSubCollectionRow;